// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { UseQueryResult } from '@tanstack/react-query';
import { ParticipantService } from '@daml.js/dtc-registry-app/lib/Dtc/Registry/App/V3/Service/Participant';
import TemplateContract from '../../../../utils/TemplateContract';
import { useOperatorBasedQuery } from '../../useOperatorBasedQuery';

export const useParticipantServices: () => UseQueryResult<
  TemplateContract<ParticipantService>[],
  string
> = () =>
  useOperatorBasedQuery('queryParticipantServices', (ledgerApi, offset, operator) =>
    ledgerApi.queryParticipantServices(offset, operator),
  );

const servicesByParticipant = (data?: TemplateContract<ParticipantService>[]) => {
  const res = {} as { [key: string]: TemplateContract<ParticipantService> };
  (data || []).forEach((d) => {
    res[d.payload.participant] = d;
  });
  return res;
};

export const useParticipantServicesByParty = () => {
  const participantServicesQuery = useParticipantServices();

  return servicesByParticipant(participantServicesQuery.data);
};
